import { createGlobalStyle, css, DefaultTheme, GlobalStyleComponent } from 'styled-components'

type GlobalStylesProps = {
  removeBg?: boolean
}
// @ts-ignore
const GlobalStyles: GlobalStyleComponent<GlobalStylesProps, DefaultTheme> = createGlobalStyle`

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  ${({ theme, removeBg }) => css`
    html {
      font-size: 62.5%;
    }

    body {
      font-family: ${theme.font.family};
      font-size: ${theme.font.sizes.small};
      ${!removeBg &&
    css`
        background: ${theme.colors.mainBg};
        color: ${theme.colors.white};
      `};
    }
  `}

  .animation {
    animation-duration: 0.3s;
    -webkit-animation-duration: 0.3s;
    -webkit-animation-name: slideIn;
    animation-name: slideIn;
  }

  @keyframes slideIn {
    0% {
      transform: translateY(1rem);
      opacity: 0;
    }
    100% {
      transform: translateY(0rem);
      opacity: 1;
    }
    0% {
      transform: translateY(1rem);
      opacity: 0;
    }
  }
  /* work-sans-300 - latin */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    src: local(''),
        url('/fonts/work-sans-v8-latin-300.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
  }
  /* work-sans-regular - latin */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: local(''),
    url('/fonts/work-sans-v8-latin-regular.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
  }
  /* work-sans-600 - latin */
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    src: local(''),
    url('/fonts/work-sans-v8-latin-600.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
  }

/* ----------------------------------------------------------------------------------------------------
Reset Link
----------------------------------------------------------------------------------------------------*/

a,
a:hover,
a:active,
a:visited {
  text-decoration: none;
  color: inherit;
}
/* ----------------------------------------------------------------------------------------------------
Super Form Reset
----------------------------------------------------------------------------------------------------*/
input,
label,
select,
button,
textarea
{
margin:0;
border:0;
padding:0;
display:inline-block;
vertical-align:middle;
white-space:normal;
background:none;
line-height:1;

/* Browsers have different default form fonts */
font-size:13px;
font-family:Roboto;
}

/* Remove the stupid outer glow in Webkit */
input:focus
{
outline:0;
}

/* Box Sizing Reset
-----------------------------------------------*/

/* All of our custom controls should be what we expect them to be */
input,
textarea
{
-webkit-box-sizing:content-box;
-moz-box-sizing:content-box;
box-sizing:content-box;
}

/* These elements are usually rendered a certain way by the browser */
button,
input[type=reset],
input[type=button],
input[type=submit],
input[type=checkbox],
input[type=radio],
select
{
-webkit-box-sizing:border-box;
-moz-box-sizing:border-box;
box-sizing:border-box;
}

/* Text Inputs
-----------------------------------------------*/

input[type=date],
input[type=datetime],
input[type=datetime-local],
input[type=email],
input[type=month],
input[type=number],
input[type=password],
input[type=range],
input[type=search],
input[type=tel],
input[type=text],
input[type=time],
input[type=url],
input[type=week]
{
}

/* Button Controls
-----------------------------------------------*/

input[type=checkbox],
input[type=radio]
{
width:13px;
height:13px;
}

/* File Uploads
-----------------------------------------------*/

input[type=file]
{

}

/* Search Input
-----------------------------------------------*/

/* Make webkit render the search input like a normal text field */
input[type=search]
{
-webkit-appearance:textfield;
-webkit-box-sizing:content-box;
}

/* Turn off the recent search for webkit. It adds about 15px padding on the left */
::-webkit-search-decoration
{
display:none;
}

/* Buttons
-----------------------------------------------*/

button,
input[type="reset"],
input[type="button"],
input[type="submit"]
{
/* Fix IE7 display bug */
overflow:visible;
width:auto;
}

/* IE8 and FF freak out if this rule is within another selector */
::-webkit-file-upload-button
{
padding:0;
border:0;
background:none;
}

/* Textarea
-----------------------------------------------*/

textarea
{
/* Move the label to the top */
vertical-align:top;

/* Turn off scroll bars in IE unless needed */
overflow:auto;
}

/* Selects ------------------------------------
-----------------------------------------------*/

select
{

}

select[multiple]
{
/* Move the label to the top */
vertical-align:top;
}
/* Custom Scroll ------------------------------------
-----------------------------------------------*/
::-webkit-scrollbar {
  width: 0.5rem;
}
/* Track */
::-webkit-scrollbar-track {
  background: #5F697E;
  border-radius: 2rem;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 2rem;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
/* React Tabs ------------------------------------
-----------------------------------------------*/
.react-tabs__tab-list {
  border-bottom:none;
  padding: 0;
  font-size: 1.4rem;
  margin: 0;
}

.react-tabs__tab {
  padding: 0;
  cursor: pointer;
}
.react-tabs__tab:first-child {
  margin-right:1rem;
}
.react-tabs__tab--selected {
  font-weight:bold;
  border:none;
}

.react-tabs__tab:focus {
  box-shadow: none;
  border-color: transparent;
  outline: none;
}

.react-tabs__tab:focus:after {
  background:transparent;
}
/* React StockCharts ------------------------------------
-----------------------------------------------*/


/* Duf header overrides */
.duf-header {
  &-wallet-container {
    @media only screen and (max-width: 1112px) {
      background: #1E1628 !important;
    }
  }
  .duf-header-wrapper__right {
    background: #1E1628;
  }
  .duf-header-logo-text {
    display: none;
  }
}

.duf-networkSelector {
  &-buttonContent {
    min-height: 4rem;
    background: #616472 !important;
    transition: all ease-in-out 0.1s;

    &:hover {
      background: #926CE3 !important;
      opacity: 1 !important;
    }
  }

  &-menu {
    background: #1e172e !important;
  }
}

/* duf sidebar overrides */
.duf-aside {
  background: #1E1628 !important;
  z-index: 1025 !important;

  @media only screen and (max-width: 834px) {
    z-index: 1022 !important;
  }

  &-container {
    &.sidebar-expanded .duf-aside-control {
      height: unset;
    }

    @media only screen and (max-width: 834px) {
      background: #1E1628 !important;
    }
  }  

  .duf-aside-logo {
    a {
      cursor: pointer;
    }
  }


  .duf-sidebar {
    &-link {
      a figure img {
        border-radius: 0 !important;
      }
      a figure {
        display: flex;
        justify-content: center;
      }
      a figure svg {
        width: 19px;
        height: 19px;
        fill: none;
        vertical-align: sub;

        & path {
          fill: none;
        }
      }

      &.wide:hover:not(.active) {
        background: #272727;
      }

      &.active.wide span {
        color: #9465c3;
      }
    }
    &-link-icon {
      display: none;
    }
  }

  .duf-sidebar-language button {
    display: none; // Hidden (Meir request) until we add more languages
    background: #181422;
    opacity: 1;
  }
  .duf-sidebar-textbox {
    display: none;
  }
  .duf-sidebar-link {
    a figure img {
      border-radius: 0 !important;
    }

    &.active.wide {
      background: #332b48;
    }

    &.wide:hover:not(.active) {
      background: #272727;
    }

    &.active.wide span {
      color: #9465c3;
    }
  }
}


/* Intercom overides */
.intercom-lightweight-app-launcher {
  background: #7D4EE0 !important;
}

/* Web3 wallet connector overides */
.web3-wc_modal_container {
  background: #0e051c !important;
}

.web3-wc_wallet-wrapper {
  background: #240d47 !important;
}

.web3-wc_nowallet-wrapper {
  background: #240d47 !important;
}

.web3-wc_connect-wallet-button {
  color: #fff;
  background: linear-gradient(90deg, #6629e7, #931be3);
  border: none;

  &_balance {
    color: #926CE3 !important;
  }  

  &:hover:not(:disabled) {
    background: linear-gradient(90deg, #824bf7, #a639ee);
    color: #fff;
  }

  &.connected {
    background: none;
    border: 1px solid #926CE3;

      &:hover {
      background: #1e172e;
      color: unset;
      border-color: #926CE3;
    }
  }
}

// Sidebar links active state overrides
.duf-sidebar-link.active:not(.wide) {
  & svg {
    fill: #926ce3;
    stroke: #926ce3;

    & path {
      fill: #926ce3;
      stroke: #926ce3;
    }
  }
}

.duf-sidebar-link.active {
  & svg {
    fill: #926ce3 !important;
    stroke: #926ce3;

    & path {
      fill: #926ce3 !important;
      stroke: #926ce3;
    }
  }

  &.wide {
    background: #332b48 !important;
  }

  &:not(.wide) {
    background: #332b48 !important;
  }
}

// Sidebar links hover state overrides
.duf-sidebar-link.wide:hover:not(.active) svg path {
  stroke: #fff !important;
  fill: none !important;
}

.duf-sidebar-link:hover:not(.active) svg path {
  stroke: #fff !important;
  fill: none !important;
}
`

export default GlobalStyles
